import { APIClient } from 'cx-api-client-lite';
import { stringify } from 'query-string';

import unwrapData from 'app/libs/unwrapData';

/**
 * For each request in CR_API we need to unwrap data, returned. That's why we are using function unwrapData
 */
const Crapi = new APIClient({
  fetchUserData: {
    path: 'get_upsell_data.0.json',
    method: 'GET',
    transformResponse: unwrapData,
    options: {
      withCredentials: true,
      params: { sess_id: 1 },
    },
  },
  freeTrialInfo: {
    path: 'free_trial_info.1.json',
    method: 'GET',
    transformResponse: unwrapData,
    options: {
      withCredentials: true,
      params: { sess_id: 1 },
    },
  },
  login: {
    path: 'login.1.json',
    method: 'POST',
    transformResponse: unwrapData,
    options: {
      withCredentials: true,
      params: { sess_id: 1 },
      transformRequest: stringify,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    },
  },
  registration: {
    path: 'signup.0.json',
    method: 'POST',
    transformResponse: unwrapData,
    options: {
      withCredentials: true,
      params: { sess_id: 1 },
      transformRequest: stringify,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    },
  },
  checkCaptcha: {
    path: 'captcha.0.json',
    method: 'GET',
    transformResponse: unwrapData,
    options: {
      withCredentials: true,
      params: { sess_id: 1 },
    },
  },
  fetchSubscriptions: {
    path: 'subscription_package.1.json',
    method: 'GET',
    transformResponse: unwrapData,
    options: {
      withCredentials: true,
      params: { sess_id: 1 },
    },
  },
  validateCoupon: {
    path: 'get_coupon_details.0.json',
    method: 'GET',
    transformResponse: unwrapData,
    options: {
      withCredentials: true,
      params: { sess_id: 1 },
    },
  },
  setMarketingReferrer: {
    path: 'set_marketing_referrer.0.json',
    method: 'POST',
    transformResponse: unwrapData,
    options: {
      withCredentials: true,
      params: { sess_id: 1 },
      transformRequest: stringify,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    },
  },
});

export default Crapi;
